@if (!generalConfigErrors) {
  <div>
    <p-tabs [scrollable]="true" [value]="activeTab">
      <p-tablist>
        @for (item of tabItems; track item) {
          <p-tab [value]="item.value" [routerLink]="item.routerLink">{{ item.label }}</p-tab>
        }
      </p-tablist>
    </p-tabs>
    <div class="card">
      <router-outlet></router-outlet>
    </div>
    <p-confirmDialog>
    </p-confirmDialog>
    <p-toast></p-toast>
  </div>
}
<edu-udo-itmc-dev-mini-book-error-renderer [errors]="generalConfigErrors"></edu-udo-itmc-dev-mini-book-error-renderer>
